// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Aggregation functions enum.
 */
export enum AggregationTypeEnum {
  None = 0,
  Count = 1,
  CountDistinct = 2,
  CountDistinctApprox = 3,
  Sum = 4,
  Avg = 5,
  Min = 6,
  Max = 7
}
